import { gql } from '@apollo/client'

import { FormModelFragment } from '../fragments'

export const MUTATION_CREATE_FORM_MODEL = gql`
  mutation createFormModel($input: FormModelCreateInput!) {
    createFormModel(input: $input) {
      ...FormModelFragment
    }
  }
  ${FormModelFragment}
`

export const MUTATION_UPDATE_FORM_MODEL = gql`
  mutation updateFormModel($input: FormModelUpdateInput!) {
    updateFormModel(input: $input) {
      ...FormModelFragment
    }
  }
  ${FormModelFragment}
`

export const MUTATION_DUPLICATE_FORM_MODEL = gql`
  mutation duplicateFormModel($input: FormModelDuplicateInput!) {
    duplicateFormModel(input: $input) {
      ...FormModelFragment
    }
  }
  ${FormModelFragment}
`

export const MUTATION_DELETE_FORM_MODEL = gql`
  mutation deleteFormModel($id: ID!) {
    deleteFormModel(id: $id)
  }
`

export const MUTATION_UPDATE_FORM_MODEL_VISIBLE = gql`
  mutation updateFormModelVisible($input: FormModelUpdateVisibleInput!) {
    updateFormModelVisible(input: $input)
  }
`

export const MUTATION_IMPORT_FORM_MODELS = gql`
  mutation importFormModels($input: FormModelImportInput!) {
    importFormModels(input: $input)
  }
`
